import { LinkedList } from '@/utils/linkedlist';
interface Point {
  x: string;
  y: string;
}
interface PointZ extends Point {
  z: string;
}

export enum PlayStateEnum {
  play = 0,// 播放种
  jump = 1,//加载数据中，
  pause = -1,//暂停中
}

export const DrivingModeMap = {
  0: {
    title: '未知',
    value: 0,
    class: 'icon-weizhizhuangtai red',
  },
  1: {
    title: '初始化',
    value: 1,
    class: 'icon-chushihua',
  },
  2: {
    title: '自动驾驶',
    value: 2,
    class: 'icon-wurenjiashi',
  },
  3: {
    title: '安全模块控制',
    value: 3,
    class: 'icon-anquankongzhi',
  },
  4: {
    title: '安全模块缓刹',
    value: 4,
    class: 'icon-caichache',
  },
  5: {
    title: '远程接管',
    value: 5,
    class: 'icon-yuanchengkongzhi',
  },
  6: {
    title: '安全模块急刹',
    value: 6,
    class: 'icon-chache',
  },
  7: {
    title: '安全模块禁止某个方向行驶',
    value: 7,
    class: 'icon-jinzhide red',
  },
  8: {
    title: '远程超管',
    value: 8,
    class: '.icon-iconchaoguanquanxian',
  },
  9: {
    title: '手柄接管',
    value: 9,
    class: 'icon-shoubing',
  },
  10: {
    title: '底盘就绪',
    value: 10,
    class: 'icon-xinxinicon green',
  },
  11: {
    title: '底盘遥控接管',
    value: 11,
    class: 'icon-dipandiannaokongzhixitong',
  },
  12: {
    title: '防撞触发',
    value: 12,
    class: 'icon-fangzhuangshebeidingwei',
  },
  13: {
    title: '底盘错误信息',
    value: 13,
    class: 'icon-xinxinicon red',
  },
  14: {
    title: '急停按钮触发',
    value: 14,
    class: 'icon-jichache red',
  },
};
export const GearPositionMap = {
  0: {
    title: '其它',
    value: 0,
    class: 'red',
    text: '···',
  },
  1: {
    title: '空档',
    value: 1,
    class: '',
    text: 'N',
  },
  2: {
    title: '行驶',
    value: 2,
    class: '',
    text: 'D',
  },
  3: {
    title: '倒',
    value: 3,
    class: '',
    text: 'R',
  },
  4: {
    title: '泊车',
    value: 4,
    class: '',
    text: 'P',
  },
  5: {
    title: '低速',
    value: 5,
    class: '',
    text: 'L',
  },
  6: {
    title: '非法',
    value: 6,
    class: 'red',
    text: '!',
  },
  7: {
    title: '未知',
    value: 7,
    class: 'red',
    text: '?',
  },
  8: {
    title: '运动',
    value: 8,
    class: '',
    text: 'S',
  },
};
export interface WsStateTypes {
  ws: WebSocket | any;
  list: any[];
  data:
    | {
        timestamp: number;
        sensorData: any;
        vehicleData: {
          origin: PointZ;
          origin_center: PointZ;
          planning: {
            path: Point[];
            trajectory: Point[];
          };
          vehicle: {
            acceleration: string;
            drivingMode: keyof typeof DrivingModeMap;
            gearPosition: keyof typeof GearPositionMap;
            orientation: PointZ;
            polygon: Point[];
            steerAngle: number;
            velocity: string;
            turnSignalState: any;
          };
        };
        map_data: {
          boundary: {
            id: string;
            point: Point[];
          }[];
          cross_walk: {
            id: string;
            point: Point[];
          }[];
          intersection: {
            id: string;
            point: Point[];
          };
          lane: {
            id: string;
            type: string;
            point: Point[];
          }[];
          prohibited_area: {
            id: string;
            point: Point[];
          }[];
          stop_line: {
            id: string;
            type: string;
            point: Point[];
          }[];
          traffic_light: {
            id: string;
            angle: string;
            position: PointZ;
          }[];
        };
      }
    | any;
  allData: any;
  allData_index: number;
  speed: number;
  timer: any;
  listIndex: number;
  vehicleInfo: any;
  totalLength: number;
  playLoading: any;
  cameraInfo: any;
  allMapData: any;
  isSelectpoint: any;
  wsBaseUrl: string | boolean | undefined;
  moduleLists: [];
  currentModule: [];
  timeout: number;
  recordLists: any;
  dirWs: any;
  dirWsTimer: any;
  dirTask: any;
  wsTimer: any;
  wsReloadCount: number;
  allData_len: number;
  isJump: number;
  allChannelList: any;
  currentChannelList: any;
  vehicleId: string;
  business_id: any;
  playlist: [];
  playbackState: PlayStateEnum;//当前播放的状态，播放 暂停 数据加载中
  createTimestamp: number;
  playcache: LinkedList;
  startts: number;
  playIntervalTs: any;
  serverSendState: number;
  initTs: number;
  wsstate: number;
  cars: {
    carSn: string;
    vehicleId: number;
    carName: string;
  }[];
  // 当前播放时间段的开始结束时间
  playItem: number[];
  playTimeMiss: number[];
  // 开启逐帧模式
  nextFrameMode: boolean;
  prevCache: any[];
  prevFlag: number;
  nextFlag: number;
  isTimeRangeNoData: boolean;
}
